import { makeReducer } from "../../core/make-reducer";
import ViewerMethod from "../../core/ViewerMethod";

const spine = makeReducer(ViewerMethod.GET_SPINE, undefined, []);

export default spine;
